<template>
    <!--横向填空-->
    <div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">{{$t('main.FillInTheBlankHorizontally')}}</p>
        <el-row :gutter="10" class="question-box">
            <el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
                {{ question.quesIndex + 1 }}
            </el-col>
            <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title" @click="setActiveInput(question.qid)">
                
                <span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				<TitleEditor 
                    :isTest="true"
                    class="outline-none " 
                    :qid="question.qid" 
                    :class="question.qid"  
                    :value="question.questionsName" 
                    :actionTitleEditorShow="activeInputId === question.qid"
                    @childValueChange="val=>{ question.questionsName = val }" 
                ></TitleEditor>
            </el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<OperateWrap
					style="display: flex;
						width: 100%;
						justify-content: end;
					"
					:bankId="$route.query.bankId"	
					:question="question"
				></OperateWrap>
			</el-col>
        </el-row>
        <el-row :gutter="10" style="margin-top: 12px !important;margin-bottom: 12px">
            <div >
                <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16"
                    class="el_item_option" style="margin-left:50px">
                    <!-- <el-input v-model="question.quesOptionTitle" placeholder="请输入内容"></el-input> -->
                    <div class=" quesOptionTitle-box">
                        
                        <div @click="setActiveInput(`quesOption${question.qid}`)">
                            <span v-if="isBankViewTest">{{item.questionsName}}</span>
                            <TitleEditor
                                v-if="!isBankViewTest" 
                                class="outline-none quesOptionTitle" 
                                :qid="`quesOption${question.qid}`" 
                                :class="`quesOption${question.qid}`"  
                                :value="question.quesOptionTitle" 
                                :actionTitleEditorShow="activeInputId === `quesOption${question.qid}`"
                                :isAcross="true"
                                @childValueChange="childValueChange" 
                            ></TitleEditor>
                        </div>
                        <div class="control" style="display: flex;">
                            <i
                            class="el-icon-s-tools el-icon-common-option"
                            @click.stop="setQuestion"
                            ></i>
                            <el-tooltip 
                                :content="$t('main.TheLengthDeterminesTheWidthOfFillingInTheBlanks')" 
                                placement="top" 
                                effect="light"
                            >
                                <i class="el-icon-question  el-icon-common-option"></i>
                            </el-tooltip>
                        </div>
                    </div>
                </el-col>
            </div>

        </el-row>
    <!-- 横向填空题设置 -->
    <el-dialog
      :title="$t('main.FillInTheBlankAttribute')"
      :visible.sync="horizontalDialog"
      width="1000px"
      :before-close="() => {horizontalDialog = false}" :close-on-click-modal="false"
      :append-to-body="true"
      >
      <span style="line-height: 40px;" v-html="question.quesOptionTitle"></span>
      <el-table
        @selection-change="horizontalChange"
        :data="optionList"
        ref="multipleTable"
        border
        style="width: 100%"
        :style="{'--ThisBlankIsMandatory': ThisBlankIsMandatory}"
        >
        <el-table-column
          :label="$t('main.FillInTheBlankNumber')"
          width="100"
          align="center">
          <template #default='scope'>{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column
          :label="$t('main.ContentRestrictions')"
          width="180"
          align="center">
          <template #default='scope'>
            <el-select
                v-model="scope.row.format"
                :popper-append-to-body="false"
                :placeholder="$t('main.noLimit')"
                size="mini"
                @change="formatChange(scope.row)" style="width: 130px;"
            >
              <el-option
                v-for="item in formatList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('main.Range')"
          align="center">
          <template #default='scope'>
            <div class="table-range">
                <div class="table-item" v-if="scope.row.format == '1'" >
                    保留小数
                    <el-select v-model="scope.row.decimalPlaces" placeholder="请选择" size="mini" style="width: 130px;">
                        <el-option v-for="item in 6" :key="item - 1" :label="item - 1" :value="item - 1"></el-option>
                    </el-select>
                </div>
                <div v-if="scope.row.minNum  != undefined
                    && 
                    (scope.row.format == '0' 
                    || scope.row.format == '1'
                    || scope.row.format == '2'
                    || scope.row.format == '3'
                    || scope.row.format == '4'
                )"  class="table-item">
                
                    <span v-if="scope.row.format == '1'">最小值 </span>
                    <span v-else>最少字数 </span>
                    <PopoverNum
                        :value="scope.row.minNum"
                        controls-position="right"
                        :size="'mini'"
                        :min="scope.row.minNum"
                        :max="scope.row.maxNum"
                        :type="'min<max'"
                        :maxlength="4"
                        :content="scope.row.format == '1' ? '最小值不得大于等于最大值' : '最少字数不得大于等于最大字数'"
                        :valueType="scope.row.format == '1' ? 'numValue' : 'lengthValue'"
                        @valueChange="(val) => scope.row.minNum = val"
                    >
                        </PopoverNum>
                <!-- <el-input-number 
                    class="range-input"
                    v-model.number="scope.row.maxNum"
                    controls-position="right"
                    :min="1" ></el-input-number> -->
                </div>
                <div v-if="scope.row.maxNum  != undefined
                    && 
                    (scope.row.format == '0' 
                    || scope.row.format == '1'
                    || scope.row.format == '2'
                    || scope.row.format == '3'
                    || scope.row.format == '4'
                )"  class="table-item">
                    <span v-if="scope.row.format == '1'">最大值 </span>
                    <span v-else>最多字数 </span>
                    <PopoverNum
                        :value="scope.row.maxNum"
                        controls-position="right"
                        :size="'mini'"
                        :min="scope.row.minNum"
                        :max="scope.row.maxNum"
                        :type="'min>max'"
                        :maxlength="4"
                        :content="scope.row.format == '1' ? '最大值不得小于等于最小值' : '最多字数不得小于等于最少字数'"
                        :valueType="scope.row.format == '1' ? 'numValue' : 'lengthValue'"
                        @valueChange="(val) => scope.row.maxNum = val"
                    >
                    </PopoverNum>
                </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          type="selection"
          :label="$t('main.ThisBlankIsMandatory')"
          width="200"
          align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="horizontalDialog = false">{{$t('main.cancel2')}}</el-button>
        <el-button size="small" type="primary" @click="horizontalSubmit">{{$t('main.ok2')}}</el-button>
      </span>
    </el-dialog>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { v1 as UUID } from "uuid"
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import CheckType from '@/util/JSON/checkType.json';
import PopoverNum from "@/components/myComponents/popoverNum.vue"
import OperateWrap from "./collectToBank/operateaWrap.vue"
    export default {
        components:{
            TitleEditor,
            PopoverNum,
            OperateWrap
        },
        data() {
            return {
                ThisBlankIsMandatory: `"${this.$t('main.ThisBlankIsMandatory')}"`,
                horizontalDialog: false,
                horizontalSetObj: {},
                optionList: [],
                multipleSelection: [],
            }
        },
        computed: {
            ...mapState(['activeInputId']),
            //选项验证类型
            formatList () {
                return CheckType
            }
        },
        props: {
            question: {},
            index: {type:Number,default:0},
            // 管理题库时查看试题 只可以删除
            isBankViewTest: {
                type: Boolean,
                default: false
            },
        },
        methods: {
            ...mapActions(['setActiveInput']),
            formatChange(data) {
                if(data.format != 1) {
                    data.decimalPlaces = 0
                    if (data.minNum < 0) data.minNum = 0
                    if (data.maxNum < 0) data.maxNum = 0
                }
            },
            childValueChange(val){
                console.log()
                this.question.quesOptionTitle = val
                this.quesOptionTitleBlur()
            },
            quesOptionTitleBlur() {
                // this.question.quesOptionTitle = this.$refs.quesOptionTitle.innerHTML
                let arr = this.question.quesOptionTitle.match(/_[_]+_/g)
                console.log(arr)
                let num = arr.length - this.question.optionList.length
                if (num > 0){
                    for (let i = 0; i < num; i++){
                        let obj = {
                            oid: UUID(),
                            length: 0,
                            labelName: 0,
                            optionScore: 0,
                            format: 0, // 输入框格式
                            mustanswer: true,
                            minNum: 0,
                            maxNum: 0,
                            decimalPlaces: 0
                        }
                        this.question.optionList.push(obj)
                    }
                    arr.forEach((info, index) => {
                        this.question.optionList[index].length = info.length
                        this.question.optionList[index].labelName = index + 1
                    })
                } else {
                    this.question.optionList.length = arr.length
                }
            },
            // 设置
            setQuestion() {
                this.optionList = JSON.parse(JSON.stringify(this.question.optionList))
                this.horizontalDialog = true
                this.$nextTick(() => {
                    this.optionList.forEach((info) => {
                        if (info.mustanswer) {
                            this.$refs.multipleTable.toggleRowSelection(info, true)
                        }
                    })
                })
            },
            horizontalChange(val){
                this.multipleSelection = val
            },
            horizontalSubmit() {
                let arr = []
                if (this.multipleSelection.length > 0) {
                    this.multipleSelection.forEach((el) => {
                        arr.push(el.oid)
                    })
                }
                this.optionList.forEach(item =>{
                    item.mustanswer = false
                    if(arr.indexOf(item.oid) != -1) {
                        item.mustanswer = true
                    }
                })
                this.question.optionList = JSON.parse(JSON.stringify(this.optionList))
                this.horizontalDialog = false
            },
            setEditIndex(index){
                this.$emit("setEditIndex",index);
            },
        },
        created() {
            // console.log('questionBlank',this.question)
        }
    }
</script>

<style scoped lang="scss">
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
    .el_item_option {
        line-height: 40px;
        // height: 44px;
    }

    .el-icon-common {
        margin-right: 23px;
        font-size: 16px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    .el-icon-common-option {
        margin-left: 10px;
        font-size: 22px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }

    
.outline-none{
  outline: none;
  width: 100%;
}
.quesOptionTitle-box{
    width: 100%;
    display: flex;
    align-items: flex-start;
    .quesOptionTitle{
        font-size: 14px;
    }
}
/deep/.el-input__inner{
    border: 1px solid #dcdfe6 !important;
}
/deep/.el-table__header .el-table-column--selection .cell .el-checkbox:after {
    content: var(--ThisBlankIsMandatory);
    // content: '此空必填';
}
.table-range{
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .table-item+.table-item{
        margin-left: 2px;
    }
}
</style>
